// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "audio_asset".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "audio_asset" table (1:1 with a DB row, on the wire). */
export const audioAssetAtomSchema = z.object({
    id: z.string(),
    kind: z.string(),
    hash: z.string(),
    url: z.string().nullable(),
    durationMs: z.number().nullable(),
    payload: z.string().nullable(),
    organizationId: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=audioAsset.js.map